'use client';

import { forwardRef, useImperativeHandle } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CompanyFields } from '@/shared/ui/forms/company-fields';
import { companySchema, type CompanyFormData } from '@/shared/lib/validation/registration-wizard/company';
import type { FormHandle } from '@/shared/ui/forms/form-handle';


type Props = {
    defaultValues?: Partial<CompanyFormData>;
    onSubmit: (data: CompanyFormData) => void;
};


export const CompanySubForm = forwardRef<FormHandle<CompanyFormData>, Props>(function CompanySubForm ({ defaultValues, onSubmit }, ref) {
    const form = useForm<CompanyFormData>({
        resolver      : zodResolver(companySchema),
        mode          : 'onBlur',
        reValidateMode: 'onChange',
        defaultValues : {
            address     : '',
            city        : '',
            company_name: '',
            company_vat : '',
            country     : '',
            postal_code : '',
            ...defaultValues,
        },
    });

    useImperativeHandle(ref, () => ({
        submit: async () => {
            const valid = await form.trigger();
            if (!valid) return null;
            const values = form.getValues();
            onSubmit(values);
            return values;
        },
    }));

    return (
        <FormProvider { ...form }>
            <CompanyFields/>
        </FormProvider>
    );
});
